module.exports = __webpack_public_path__ + "images/missing-inventory-a60ebe46.svg";